module.exports = __webpack_public_path__ + "img/20.075060f5.png";